export const environment = {
  env: 'qat',

  apis: {
    auth: 'https://auth.mbpi-qat.com',
    cc: 'https://cc.mbpi-qat.com',
    portal: 'https://portal.mbpi-qat.com',
  },

  agencyLogoBaseUrl: 'assets/images/agent',
  dealerLogoBaseUrl: 'assets/images/dealer',
  profilePhotoBaseUrl: 'assets/images/user',
  noLogoUrl: 'assets/images/nologo.png',
  noAvatar: 'noavatar.png',

  notificationAppID: 'c32b4bf5-b981-4855-8539-2fbff677d6a6',

  ngxs: {
    logger: 'false',
    devTools: 'false',
  },

  logRocket: {
    on: 'true',
    appId: 'yinczu/mbpi-portal-ui-dev',
  },

  routing: {
    enableTracing: false,
  },

  version: {
    url: 'version.json',
    frequency: 1000 * 60 * 10,
  },

  legacyHostName: 'secure.mbpnetwork.com',
};
